import { render } from "./TripManagerMenu.vue?vue&type=template&id=596f374d&scoped=true"
import script from "./TripManagerMenu.vue?vue&type=script&lang=js"
export * from "./TripManagerMenu.vue?vue&type=script&lang=js"

import "./TripManagerMenu.vue?vue&type=style&index=0&id=596f374d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596f374d"]])

export default __exports__